export interface IDisputeStatusUpdatePayload {
  isDisputeFiled: boolean;
  message: string;
  deductionInfo: {
    deductionId: number;
    claimNumber: string;
    remittanceItemId: number;
  };
  disputeInfo: {
    disputeId: number;
  };
  brandInfo: {
    brandKey: string;
  };
  purchaserInfo: {
    purchaserKey: string;
  };
  userInfo: {
    userId: number;
  };
}

export enum DisputeEvents { 
  DISPUTE_STATUS_UPDATE = "DISPUTE_STATUS_UPDATE",
}

export interface IDisputeEventsMap {
  [DisputeEvents.DISPUTE_STATUS_UPDATE]: DisputeStatusUpdatePayload;
}

export class DisputeStatusUpdatePayload implements IDisputeStatusUpdatePayload {
  private readonly _isDisputeFiled: boolean;
  private readonly _message: string;
  private readonly _deductionInfo: {
    deductionId: number;
    claimNumber: string;
    remittanceItemId: number;
  };
  private readonly _disputeInfo: {
    disputeId: number;
  };
  private readonly _brandInfo: {
    brandKey: string;
  };
  private readonly _purchaserInfo: {
    purchaserKey: string;
  };
  private readonly _userInfo: {
    userId: number;
  };

  constructor(data: IDisputeStatusUpdatePayload) {
    this._isDisputeFiled = data.isDisputeFiled;
    this._message = data.message;
    this._deductionInfo = data.deductionInfo;
    this._disputeInfo = data.disputeInfo;
    this._brandInfo = data.brandInfo;
    this._purchaserInfo = data.purchaserInfo;
    this._userInfo = data.userInfo;
  }

  public get isDisputeFiled(): boolean {
    return this._isDisputeFiled;
  }
  public get message(): string {
    return this._message;
  }
  public get deductionInfo(): {
    deductionId: number;
    claimNumber: string;
    remittanceItemId: number;
  } {
    return this._deductionInfo;
  }
  public get disputeInfo(): {
    disputeId: number;
  } {
    return this._disputeInfo;
  }
  public get brandInfo(): {
    brandKey: string;
  } {
    return this._brandInfo;
  }
  public get purchaserInfo(): {
    purchaserKey: string;
  } {
    return this._purchaserInfo;
  }
  public get userInfo(): {
    userId: number;
  } {
    return this._userInfo;
  }
  public toJSON(): IDisputeStatusUpdatePayload {
    return {
      isDisputeFiled: this._isDisputeFiled,
      message: this._message,
      deductionInfo: this._deductionInfo,
      disputeInfo: this._disputeInfo,
      brandInfo: this._brandInfo,
      purchaserInfo: this._purchaserInfo,
      userInfo: this._userInfo,
    };
  }
}

